import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	getConceptStatusValue,
	mergeHistoricalPrescriptions,
	PrescriptionHistoryConcept,
	PrescriptionReviewConcept,
	RPrescriptionHistoryItem,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { RPrescription } from "@fusion-advantage/backcompat"
import { setPrescriptions, setPrescriptionHistory } from "../../redux/drugSlice"

export class PrescriptionReviewModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const statusForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rModels = z.array(RPrescription).safeParse(statusForCid(PrescriptionReviewConcept.cid))
		if(!rModels.success) {
			return err(serializeFusionError('PrescriptionReviewModelReduxPersister rModels', rModels.error))
		}
		const rHistory = z.array(RPrescriptionHistoryItem).safeParse(statusForCid(PrescriptionHistoryConcept.cid))
		if(!rHistory.success) {
			return err(serializeFusionError('PrescriptionReviewModelReduxPersister rHistory', rHistory.error))
		}
		const models = mergeHistoricalPrescriptions(rModels.data, rHistory.data)
		dispatch(setPrescriptions(models))
		dispatch(setPrescriptionHistory(rHistory.data))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState) {
		return prevState.drug.models !== nextState.drug.models
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: PrescriptionReviewConcept.cid,
			value: nextState.drug.models,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
